import script from "./SharedBoxMain.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBoxMain.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/share.css?vue&type=style&index=0&id=5f371624&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f371624"]])

export default __exports__